module.exports = __webpack_public_path__ + "img/Karriere_Smartphone.b650ecb5.jpg";